export default "__VITE_ASSET__BzCWIPO9__"